import { compareStrings } from "@core/utils/array";

export enum RespondentTypeGroup {
    NoData = -1,
    TotalGroup = 0,
    Gender = 1,
    Generation = 2,
    Ethnicity = 3,
    Region = 4,
    Area = 10,
    Income = 5,
    Household = 6,
    EatingHabits = 7,
    FoodiesGroup = 8,
    HealthFocusedGroup = 9,
}

export enum RespondentType {
    NoData = 0,
    TotalUS = 1,
    Male = 2,
    Female = 3,
    GenZ = 4,
    Millennials = 5,
    GenX = 6,
    Boomers = 7,
    White = 8,
    Black = 9,
    Hispanic = 10,
    Asian = 11,
    West = 12,
    Midwest = 13,
    Northeast = 14,
    South = 15,
    Under25000 = 16,
    From25000To49000 = 17,
    From50000to74000 = 18,
    From75000To$100000 = 19,
    MoreThan100000 = 20,
    KidsUnder6 = 21,
    KidsAges6To12 = 22,
    KidsAges13To17 = 23,
    WithKids = 24,
    WithoutKids = 25,
    Foodies = 26,
    YearOld21Plus = 27,
    HealthFocused = 28,
    VeganOrVegetarian = 29,
    FlexitarianOrPescatarian = 30,
    MeatEater = 31,
    Urban = 32,
    Suburban = 33,
    Rural = 34,
}

export const ALL_RESPONDENT_TYPES = [
    RespondentType.TotalUS,
    RespondentType.Male,
    RespondentType.Female,
    RespondentType.GenZ,
    RespondentType.Millennials,
    RespondentType.GenX,
    RespondentType.Boomers,
    RespondentType.White,
    RespondentType.Black,
    RespondentType.Hispanic,
    RespondentType.Asian,
    RespondentType.West,
    RespondentType.Midwest,
    RespondentType.Northeast,
    RespondentType.South,
    RespondentType.Under25000,
    RespondentType.From25000To49000,
    RespondentType.From50000to74000,
    RespondentType.From75000To$100000,
    RespondentType.MoreThan100000,
    RespondentType.KidsUnder6,
    RespondentType.KidsAges6To12,
    RespondentType.KidsAges13To17,
    RespondentType.WithKids,
    RespondentType.WithoutKids,
    RespondentType.Foodies,
    RespondentType.YearOld21Plus,
    RespondentType.HealthFocused,
    RespondentType.VeganOrVegetarian,
    RespondentType.FlexitarianOrPescatarian,
    RespondentType.MeatEater,
    RespondentType.Urban,
    RespondentType.Suburban,
    RespondentType.Rural,
];

export const RESPONDENT_TYPE_GROUPS_ORDER = [
    RespondentTypeGroup.TotalGroup,
    RespondentTypeGroup.Gender,
    RespondentTypeGroup.Generation,
    RespondentTypeGroup.Ethnicity,
    RespondentTypeGroup.Region,
    RespondentTypeGroup.Area,
    RespondentTypeGroup.Income,
    RespondentTypeGroup.Household,
    RespondentTypeGroup.EatingHabits,
    RespondentTypeGroup.FoodiesGroup,
    RespondentTypeGroup.HealthFocusedGroup,
];

export const RESPONDENT_TYPE_ORDER = [
    RespondentType.TotalUS,
    RespondentType.Male,
    RespondentType.Female,
    RespondentType.GenZ,
    RespondentType.Millennials,
    RespondentType.GenX,
    RespondentType.Boomers,
    RespondentType.White,
    RespondentType.Black,
    RespondentType.Hispanic,
    RespondentType.Asian,
    RespondentType.West,
    RespondentType.Midwest,
    RespondentType.Northeast,
    RespondentType.South,
    RespondentType.Under25000,
    RespondentType.From25000To49000,
    RespondentType.From50000to74000,
    RespondentType.From75000To$100000,
    RespondentType.MoreThan100000,
    RespondentType.KidsUnder6,
    RespondentType.KidsAges6To12,
    RespondentType.KidsAges13To17,
    RespondentType.WithKids,
    RespondentType.WithoutKids,
    RespondentType.YearOld21Plus,
    RespondentType.VeganOrVegetarian,
    RespondentType.FlexitarianOrPescatarian,
    RespondentType.MeatEater,
    RespondentType.Urban,
    RespondentType.Suburban,
    RespondentType.Rural,
    RespondentType.Foodies,
    RespondentType.HealthFocused,
];

export function compareRespondentTypeGroups(order: RespondentTypeGroup[], a?: RespondentTypeGroup, b?: RespondentTypeGroup) {
    return compareStrings(order, a ?? RespondentTypeGroup.NoData, b ?? RespondentTypeGroup.NoData);
}

export function compareRespondentTypes(order: RespondentType[], a?: RespondentType, b?: RespondentType) {
    return compareStrings(order, a ?? RespondentType.NoData, b ?? RespondentType.NoData);
}

export const RESPONDENTS_TYPE_SINGLE_GROUPS_COLUMNS = [
    [
        RespondentTypeGroup.TotalGroup,
        RespondentTypeGroup.Gender,
        RespondentTypeGroup.Generation,
    ],
    [
        RespondentTypeGroup.Ethnicity,
        RespondentTypeGroup.Region,
    ],
    [
        RespondentTypeGroup.Area,
        RespondentTypeGroup.Income,
    ],
    [
        RespondentTypeGroup.Household,
        RespondentTypeGroup.EatingHabits,
    ],
];

export const RESPONDENTS_TYPES_WITH_TOTAL_SELECT_AMONG_GROUPS_COLUMNS = [
    [
        RespondentTypeGroup.TotalGroup,
        RespondentTypeGroup.Gender,
        RespondentTypeGroup.Generation,
        RespondentTypeGroup.Ethnicity,
    ],
    [
        RespondentTypeGroup.Region,
        RespondentTypeGroup.Area,
        RespondentTypeGroup.Income,
    ],
    [
        RespondentTypeGroup.Household,
        RespondentTypeGroup.EatingHabits,
    ],
];

export const RESPONDENTS_TYPES_SELECT_AMONG_GROUPS_COLUMNS = [
    [
        RespondentTypeGroup.Gender,
        RespondentTypeGroup.Generation,
        RespondentTypeGroup.Ethnicity,
    ],
    [
        RespondentTypeGroup.Region,
        RespondentTypeGroup.Area,
        RespondentTypeGroup.Income,
    ],
    [
        RespondentTypeGroup.Household,
        RespondentTypeGroup.EatingHabits,
    ],
];

export const RESPONDENTS_TYPES_CO_EXCLUSIVE_TYPES = [
    [
        [RespondentType.GenZ, RespondentType.Millennials, RespondentType.GenX, RespondentType.Boomers],
        [RespondentType.YearOld21Plus],
    ],
    [
        [RespondentType.KidsUnder6, RespondentType.KidsAges6To12, RespondentType.KidsAges13To17],
        [RespondentType.WithKids],
        [RespondentType.WithoutKids],
    ],
];

export const RESPONDENTS_TYPES_DESCRIPTION: Record<RespondentType, string> = {
    [RespondentType.NoData]: '',
    [RespondentType.TotalUS]: 'the general population',

    [RespondentType.Male]: 'men',
    [RespondentType.Female]: 'women',

    [RespondentType.GenZ]: 'gen z',
    [RespondentType.Millennials]: 'millennials',
    [RespondentType.GenX]: 'gen x',
    [RespondentType.Boomers]: 'boomers',
    [RespondentType.YearOld21Plus]: 'legal drinking age adults',

    [RespondentType.White]: 'white consumers',
    [RespondentType.Black]: 'black consumers',
    [RespondentType.Hispanic]: 'hispanic consumers',
    [RespondentType.Asian]: 'asian consumers',

    [RespondentType.West]: 'consumers in the west',
    [RespondentType.Midwest]: 'consumers in the midwest',
    [RespondentType.Northeast]: 'consumers in the northeast',
    [RespondentType.South]: 'consumers in the south',

    [RespondentType.Under25000]: 'consumers from households under $25k',
    [RespondentType.From25000To49000]: 'consumers from households between $25 and $49k',
    [RespondentType.From50000to74000]: 'consumers from households between $50 and $74k',
    [RespondentType.From75000To$100000]: 'consumers from households between $75 and $100k',
    [RespondentType.MoreThan100000]: 'consumers from households over $100k',

    [RespondentType.KidsUnder6]: 'parents with kids under 6',
    [RespondentType.KidsAges6To12]: 'parents with kids ages 6 to 12',
    [RespondentType.KidsAges13To17]: 'parents with teenagers',
    [RespondentType.WithKids]: 'consumers with kids',
    [RespondentType.WithoutKids]: 'consumers without kids',

    [RespondentType.Foodies]: 'foodies',
    [RespondentType.HealthFocused]: 'health-focused consumers',
    [RespondentType.VeganOrVegetarian]: 'vegans/vegetarians',
    [RespondentType.FlexitarianOrPescatarian]: 'flexitarians/pescatarians',
    [RespondentType.MeatEater]: 'meat eaters',

    [RespondentType.Urban]: 'urban',
    [RespondentType.Suburban]: 'suburban',
    [RespondentType.Rural]: 'rural',
};

export const HOME_PEOPLE_VIEW_INITIAL_RESPONDENT_TYPES = [
    RespondentType.TotalUS,
    RespondentType.Male,
    RespondentType.Female,
    RespondentType.GenZ,
    RespondentType.Millennials,
    RespondentType.GenX,
    RespondentType.Boomers,
    RespondentType.White,
    RespondentType.Black,
    RespondentType.Hispanic,
    RespondentType.Asian,
];